'use strict'
export const toc = {
    init: function (options) {
        const defaultOptions = {
            selector: '.js-toc',
            contentSelector: '.description h2',
            classList: 'nav flex-column',
            classListItem: 'nav-item',
            classLink: 'nav-link'
        }

        options = this.getOptions(defaultOptions, options)
        window.addEventListener('load', this.setup(options))
    },
    setup: function (options) {
        const tocContainer = document.querySelector(options.selector)
        const contentTitles = document.querySelectorAll(options.contentSelector)

        if (tocContainer) {
            if (contentTitles.length < 2) {
                tocContainer.remove()
                return undefined
            }

            this.tocGenerator(tocContainer, contentTitles, options)
        }
    },
    tocGenerator(tocContainer, contentTitles, options) {
        const translatedTitleAttribute = tocContainer.getAttribute('data-title')
        if (translatedTitleAttribute) {
            const titleTag = document.createElement('h2')
            titleTag.append(translatedTitleAttribute)
            tocContainer.append(titleTag)
        }

        const listTag = document.createElement('ul')
        listTag.setAttribute('class', options.classList)
        tocContainer.append(listTag)

        const list = tocContainer.querySelector('ul')
        for (let i = 0 ; i < contentTitles.length ; i++) {
            const title = contentTitles[i]
            const id = 'heading-' + i

            title.setAttribute('id', id)

            const link = document.createElement('a')
            link.setAttribute('class', options.classLink)
            link.setAttribute('href', '#'+id)
            link.append(title.textContent)

            const listItem = document.createElement('li')
            listItem.setAttribute('class', options.classListItem)
            listItem.append(link)

            list.append(listItem)
        }

        tocContainer.style.display = 'block'
    },
    getOptions(defaultOptions, initOptions) {
        for (let key in initOptions) {
            if (initOptions.hasOwnProperty(key)) {
                defaultOptions[key] = initOptions[key];
            }
        }

        return defaultOptions;
    }
}
